// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/css/loja.css
// module id = 638
// module chunks = 1